import '../App.css';
import { InputText } from 'primereact/inputtext';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import axios from 'axios';
import Header from '../Header';

function DevicesNew() {
    const navigate = useNavigate();
    const [title, setTitle] = useState('New Device');

    function createNewDevice() {
        axios.post(
            process.env.REACT_APP_API_HOST + '/devices/',
            {
                title: title,
            },
            {
                headers: {
                    'Authorization': localStorage.getItem('token'),
                }
            }
        ).then(
            (response) => {
                const device_id = response.data.device_id;
                navigate(`/device/campaigns/?device_id=${device_id}`);
            }
        )
    }

    return (
        <div>
            <Header />
            <div
                className="standard-box3"
                align='left'
                style={{ width: '90%', marginTop: '6em' }}
            >
                <h1>
                    Setup New Device
                </h1>
                <h3>
                    Title
                </h3>
                <InputText
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder='campaign title'
                    style={{ width: '50%' }}
                />
            </div>
            <div
                className="standard-box3"
                align='left'
                style={{ width: '90%' }}
            >
                <div style={{ marginTop: '2em' }}>
                    <Button
                        label="Create"
                        severity="success"
                        onClick={createNewDevice}
                        disabled={title == ''}
                        style={{ marginLeft: '0.5em' }}
                    />
                </div>
            </div>
        </div>
    );
}

export default DevicesNew;